import { render, staticRenderFns } from "./PaymentUx.vue?vue&type=template&id=6be759ae&scoped=true"
import script from "./PaymentUx.vue?vue&type=script&lang=js"
export * from "./PaymentUx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be759ae",
  null
  
)

export default component.exports